import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ValidityDatas } from '../validity-datas';

@Component({
  selector: 'atm-validity-status',
  templateUrl: './validity-status.component.html',
  styleUrls: ['./validity-status.component.scss'],
})
export class ValidityStatusComponent implements OnChanges {
  @Input() validity?: string;
  @Input() validityTz?: string;
  @Input() validityData?: ValidityDatas;
  status = 'pending';

  constructor() {

  }

  ngOnChanges(): void {
    this.validityData = new ValidityDatas(this.validity, this.validityTz);
  }

  getMonth(value: number) {
    return new Date(2000, value, 10);
  }
}
